import * as Common from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useConfig } from '../../context/ConfigContext';
import { sendExceptionToSentry } from '../../utils/errors';
import { PiccoloError } from './PiccoloError';

interface Props {
  fallback?: JSX.Element;
}

export const ErrorBoundary = (props: React.PropsWithChildren<Props>) => {
  const { fallback, children } = props;
  const configContext = useConfig();

  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => {
        sendExceptionToSentry(error);

        if (!(error instanceof Error)) {
          return <div>Not an error type</div>;
        }

        if (fallback) {
          return fallback;
        }

        return configContext.config.errorStackEnabled ? (
          <ChakraV3.ErrorOverlay error={error} />
        ) : (
          <PiccoloError
            error={
              error instanceof Common.PiccoloError
                ? error
                : new Common.PiccoloError({
                    type: 'InternalClientError',
                    message: 'Something broke. Please contact support.',
                  })
            }
          />
        );
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
